<template>
  <div class="division" :class="hasContentBelowClass">
    <div class="wrap">
      <div class="tree-arm"></div>

      <div
        class="control has-icons-left add-division"
        @click="addDivision()"
        v-if="value.isAdd"
      >
        <span class="icon is-left is-interactive">
          <i class="icon-add"></i>
        </span>
        <span class="text">Add Division</span>
      </div>

      <div class="control has-icons-right" v-if="!value.isAdd">
        <input
          v-model="value.division.name"
          class="input"
          type="text"
          aria-label="Division"
          autofocus
        />
        <span
          class="icon is-right is-interactive"
          @click="handleDivisionDelete()"
        >
          <i class="icon-close"></i>
        </span>
      </div>
    </div>
    <div class="workgroups" v-if="!value.isAdd">
      <div
        v-for="(item, index) in value.workgroups"
        class="workgroup"
        :key="index"
      >
        <div class="tree-arm"></div>
        <div class="control has-icons-right">
          <input
            v-model="item.name"
            class="input"
            type="text"
            aria-label="Workgroup"
          />
          <span
            class="icon is-right is-interactive"
            @click="handleWorkgroupDelete(item)"
          >
            <i class="icon-close"></i>
          </span>
        </div>
      </div>
      <div class="workgroup">
        <div class="tree-arm"></div>
        <div
          class="control has-icons-left add-workgroup"
          @click="addWorkgroup()"
        >
          <span class="icon is-left is-interactive">
            <i class="icon-add"></i>
          </span>
          <span class="text">Add Workgroup</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DivisionGroup',
  props: {
    value: {},
    index: 0,
    total: 0
  },
  data() {
    return {};
  },
  computed: {
    hasContentBelowClass() {
      let n_rows = Math.ceil(this.total / 4);
      let my_row = Math.ceil((this.index + 1) / 4);
      let my_column = this.index % 4;
      let last_column = this.total % 4;
      //console.log(this.index, n_rows, my_row, my_column);
      if (
        n_rows == my_row ||
        (n_rows == my_row + 1 && my_column >= last_column && last_column != 0)
      ) {
        return '';
      } else {
        return 'has-content-below';
      }
      //TODO
    }
  },
  methods: {
    handleDivisionDelete() {
      this.$emit('deleted', this.value);
    },
    handleWorkgroupDelete(workgroup) {
      for (let i = 0; i < this.value.workgroups.length; i++) {
        if (this.value.workgroups[i] == workgroup) {
          this.value.workgroups.splice(i, 1);
          break;
        }
      }
    },
    addDivision() {
      this.value.isAdd = false;
      this.$emit('added', this.value);
    },
    addWorkgroup() {
      this.value.workgroups.push({
        name: '',
        organizationLevel: 'Workgroup',
        parentGroupName: this.value.division.name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.division {
  width: 25%;
  flex-shrink: 0;
  padding: 5px 20px 8px 30px;
  position: relative;

  .add-division {
    cursor: pointer;
    .text {
      color: $link;
      padding-left: 40px;
      line-height: 45px;
    }
  }

  &.has-content-below {
    &:after {
      content: '';
      width: 1px;
      background: #555;
      height: 100%;
      position: absolute;
      top: 0;
      left: 10px;
    }
  }
}

.tree-arm {
  position: absolute;
  height: 50px;
  width: 1px;
  background: #555;
  top: -17px;
  left: 10px;

  &:after {
    content: '';
    width: 20px;
    height: 1px;
    background: #555;
    position: absolute;
    left: 0px;
    top: 50px;
  }
}
.workgroups {
  padding-top: 17px;

  .workgroup {
    position: relative;
    padding-left: 30px;
    padding-top: 6px;
  }

  .add-workgroup {
    cursor: pointer;
    .text {
      font-size: 1.5rem;
      color: $link;
      padding-left: 40px;
      line-height: 45px;
    }
  }
}
</style>
